import { MDCRipple } from '@material/ripple/index';
import { MDCList } from '@material/list';
import { MDCTextField } from '@material/textfield';
import { MDCChipSet, MDCChip } from '@material/chips';
import { MDCSelect } from '@material/select';
import { MDCCheckbox } from '@material/checkbox';
import { MDCSnackbar } from '@material/snackbar';
import { MDCSlider } from '@material/slider';
import { MDCSwitch } from '@material/switch';
import { MDCTab } from '@material/tab';
import { MDCTabBar } from '@material/tab-bar';
import { MDCMenu } from '@material/menu';
import { MDCDialog } from '@material/dialog';
import { loopThroughElements } from './utils/loop-through-elements';

declare var window: any;

export class FarmhandMcw {
    constructor() {
        this.waitForDocument();
    }

    waitForDocument = (): void => {
        if (document.readyState === "complete" || (document.readyState !== "loading" && !(document.documentElement as any).doScroll)) {
            this.initialize();
        } else {
            document.addEventListener("DOMContentLoaded", this.initialize);
        }
    };

    initialize = (): void => {
        this.attachElements(this.getClassesToAttach());
        this.bindToWindow();
    };

    getClassesToAttach = (): any => ({
        ".mdc-button": MDCRipple,
        ".mdc-list": MDCList,
        ".mdc-text-field": MDCTextField,
        ".mdc-chip-set": MDCChipSet,
        ".mdc-chip": MDCChip,
        ".mdc-select": MDCSelect,
        ".mdc-checkbox": MDCCheckbox,
        ".mdc-snackbar": MDCSnackbar,
        ".mdc-slider": MDCSlider,
        ".mdc-switch": MDCSwitch,
        ".mdc-tab-bar": MDCTabBar,
        ".mdc-tab": MDCTab,
        ".mdc-menu": MDCMenu
    });

    attachments: any[] = [];
    components: any[] = []

    attachElements = (classes): void => {
        Object.keys(classes).forEach(querySelector => {
            if (classes[querySelector]) {
                const attachment = classes[querySelector];
                const elements = document.querySelectorAll(querySelector);

                if (elements) {
                    loopThroughElements(elements, element => {
                        const component = attachment.attachTo(element);
                        this.components.push(component);
                        if (element.dataset.mdcId) {
                            this.attachments[element.dataset.mdcId] = component;
                        }

                        if (attachment === MDCChip) {
                            this.handleChipToggle(component);
                        }
                    })
                }
            }
        });
    }

    handleChipToggle = (component: MDCChip): any => component.root_.onclick = () => component.selected = !component.selected;

    bindToWindow = (): void => {
        window.mdwc = {
            _open: obj => obj.open ? obj.open() : null,
            _close: obj => obj.close ? obj.close() : null,
            snackbar: {
                open: querySelector => window.mdwc._open(new MDCSnackbar(document.querySelector(querySelector))),
                close: querySelector => window.mdwc._close(new MDCSnackbar(document.querySelector(querySelector)))
            },
            dialog: {
                open: querySelector => window.mdwc._open(new MDCDialog(document.querySelector(querySelector))),
                close: querySelector => window.mdwc._close(new MDCDialog(document.querySelector(querySelector)))
            },
            menu: {
                open: querySelector => new MDCMenu(document.querySelector(querySelector)).open = true,
                close: querySelector => new MDCMenu(document.querySelector(querySelector)).open = false
            }
        };

        window.mdc = {
            TextField: MDCTextField,
            SelectField: MDCSelect,
            Switch: MDCSwitch
        }
    };

    bindRipples = (): void => {
        const rippleSelectors = '.mdc-button, .mdc-icon-button, .mdc-card__primary-action';
        const ripples = [].map.call(document.querySelectorAll(rippleSelectors), el => new MDCRipple(el));
        const rippleClasses = ['mdc-button', 'mdc-list-item', 'mdc-icon-button', 'add-ripple'];
        const unboundedClasses = ['mdc-icon-button'];
        rippleClasses.forEach(c => {
            const elements = document.getElementsByClassName(c);
            loopThroughElements(elements, element => {
                const ripple = MDCRipple.attachTo(element);
                if (unboundedClasses.includes(c))
                    ripple.unbounded = true;
            })
        });
    }
};